export default "ac2353319419"
if (module.hot) { module.hot.accept() }
